import React from 'react';

const Copyright = ({ children }) => {

  const today = new Date();

  const copyrightStyle = {
    'marginRight': 'auto',
    'padding': 'var(--space-sm)' 
  } 

  return (
    <p style={copyrightStyle}>Copyright &#169; {children} {today.getFullYear()}</p>
  )
};

export default Copyright;